// Example usage:
//
// import { MyShape } from ./myShape.js;
//
// class MyComponent extends React.Component {
//   //
// }
//
// MyComponent.propTypes = {
//   input: MyShape
// };

import PropTypes from "prop-types";

let _NetworkBlogResponse;
let _NetworkBlogMeta;
let _PurpleLinks;
let _Post;
let _Attachment;
let _Exif;
let _AttachmentMeta;
let _FluffyLinks;
let _Thumbnails;
let _Author;
let _Capabilities;
let _Categor;
let _Uncategorized;
let _Discussion;
let _PostMeta;
let _TentacledLinks;
let _OtherUrLs;
let _Terms;
_Terms = PropTypes.shape({
    "category": _Categor,
    "post_tag": _OtherUrLs,
    "post_format": _OtherUrLs,
    "mentions": _OtherUrLs,
});
_OtherUrLs = PropTypes.shape({
});
_TentacledLinks = PropTypes.shape({
    "self": PropTypes.string,
    "help": PropTypes.string,
    "site": PropTypes.string,
    "replies": PropTypes.string,
    "likes": PropTypes.string,
});
_PostMeta = PropTypes.shape({
    "links": _TentacledLinks,
});
_Discussion = PropTypes.shape({
    "comments_open": PropTypes.bool,
    "comment_status": PropTypes.string,
    "pings_open": PropTypes.bool,
    "ping_status": PropTypes.string,
    "comment_count": PropTypes.number,
});
_Uncategorized = PropTypes.shape({
    "ID": PropTypes.number,
    "name": PropTypes.string,
    "slug": PropTypes.string,
    "description": PropTypes.string,
    "post_count": PropTypes.number,
    "parent": PropTypes.number,
    "meta": _AttachmentMeta,
});
_Categor = PropTypes.shape({
    "Uncategorized": _Uncategorized,
});
_Capabilities = PropTypes.shape({
    "publish_post": PropTypes.bool,
    "delete_post": PropTypes.bool,
    "edit_post": PropTypes.bool,
});
_Author = PropTypes.shape({
    "ID": PropTypes.number,
    "login": PropTypes.string,
    "email": PropTypes.bool,
    "name": PropTypes.string,
    "first_name": PropTypes.string,
    "last_name": PropTypes.string,
    "nice_name": PropTypes.string,
    "URL": PropTypes.string,
    "avatar_URL": PropTypes.string,
    "profile_URL": PropTypes.string,
    "site_ID": PropTypes.number,
});
_Thumbnails = PropTypes.shape({
    "thumbnail": PropTypes.string,
    "medium": PropTypes.string,
    "large": PropTypes.string,
    "newspack-article-block-landscape-large": PropTypes.string,
    "newspack-article-block-portrait-large": PropTypes.string,
    "newspack-article-block-square-large": PropTypes.string,
    "newspack-article-block-landscape-medium": PropTypes.string,
    "newspack-article-block-portrait-medium": PropTypes.string,
    "newspack-article-block-square-medium": PropTypes.string,
    "newspack-article-block-landscape-intermediate": PropTypes.string,
    "newspack-article-block-portrait-intermediate": PropTypes.string,
    "newspack-article-block-square-intermediate": PropTypes.string,
    "newspack-article-block-landscape-small": PropTypes.string,
    "newspack-article-block-portrait-small": PropTypes.string,
    "newspack-article-block-square-small": PropTypes.string,
    "newspack-article-block-landscape-tiny": PropTypes.string,
    "newspack-article-block-portrait-tiny": PropTypes.string,
    "newspack-article-block-square-tiny": PropTypes.string,
    "newspack-article-block-uncropped": PropTypes.string,
});
_FluffyLinks = PropTypes.shape({
    "self": PropTypes.string,
    "help": PropTypes.string,
    "site": PropTypes.string,
    "parent": PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
});
_AttachmentMeta = PropTypes.shape({
    "links": _FluffyLinks,
});
_Exif = PropTypes.shape({
    "aperture": PropTypes.string,
    "credit": PropTypes.string,
    "camera": PropTypes.string,
    "caption": PropTypes.string,
    "created_timestamp": PropTypes.string,
    "copyright": PropTypes.string,
    "focal_length": PropTypes.string,
    "iso": PropTypes.string,
    "shutter_speed": PropTypes.string,
    "title": PropTypes.string,
    "orientation": PropTypes.string,
    "keywords": PropTypes.arrayOf(PropTypes.any),
});
_Attachment = PropTypes.shape({
    "ID": PropTypes.number,
    "URL": PropTypes.string,
    "guid": PropTypes.string,
    "date": PropTypes.string,
    "post_ID": PropTypes.number,
    "author_ID": PropTypes.number,
    "file": PropTypes.string,
    "mime_type": PropTypes.string,
    "extension": PropTypes.string,
    "title": PropTypes.string,
    "caption": PropTypes.string,
    "description": PropTypes.string,
    "alt": PropTypes.string,
    "thumbnails": _Thumbnails,
    "height": PropTypes.number,
    "width": PropTypes.number,
    "exif": _Exif,
    "meta": _AttachmentMeta,
});
_Post = PropTypes.shape({
    "ID": PropTypes.number,
    "site_ID": PropTypes.number,
    "author": _Author,
    "date": PropTypes.string,
    "modified": PropTypes.string,
    "title": PropTypes.string,
    "URL": PropTypes.string,
    "short_URL": PropTypes.string,
    "content": PropTypes.string,
    "excerpt": PropTypes.string,
    "slug": PropTypes.string,
    "guid": PropTypes.string,
    "status": PropTypes.string,
    "sticky": PropTypes.bool,
    "password": PropTypes.string,
    "parent": PropTypes.bool,
    "type": PropTypes.string,
    "discussion": _Discussion,
    "likes_enabled": PropTypes.bool,
    "sharing_enabled": PropTypes.bool,
    "like_count": PropTypes.number,
    "i_like": PropTypes.bool,
    "is_reblogged": PropTypes.bool,
    "is_following": PropTypes.bool,
    "global_ID": PropTypes.string,
    "featured_image": PropTypes.string,
    "post_thumbnail": PropTypes.any,
    "format": PropTypes.string,
    "geo": PropTypes.bool,
    "menu_order": PropTypes.number,
    "page_template": PropTypes.string,
    "publicize_URLs": PropTypes.arrayOf(PropTypes.any),
    "terms": _Terms,
    "tags": _OtherUrLs,
    "categories": _Categor,
    "attachments": PropTypes.object,
    "attachment_count": PropTypes.number,
    "metadata": PropTypes.arrayOf(PropTypes.any),
    "meta": _PostMeta,
    "capabilities": _Capabilities,
    "other_URLs": _OtherUrLs,
});
_PurpleLinks = PropTypes.shape({
    "counts": PropTypes.string,
});
_NetworkBlogMeta = PropTypes.shape({
    "links": _PurpleLinks,
    "wpcom": PropTypes.bool,
});
_NetworkBlogResponse = PropTypes.shape({
    "found": PropTypes.number,
    "posts": PropTypes.arrayOf(_Post),
    "meta": _NetworkBlogMeta,
});

export const NetworkBlogResponse = _NetworkBlogResponse;
